import globalTheme from '../global'

const arrowWidth = 29
const arrowHeight = 12

const Tooltip = {
	MuiTooltip: {
		defaultProps: {
			arrow: true,
		},
		styleOverrides: {
			arrow: {
				color: globalTheme.palette.background.paper,
				width: arrowWidth,
				height: arrowHeight,
			},
			popper: {
				'&[data-popper-placement="left"], &[data-popper-placement="right"]': {
					'& .MuiTooltip-arrow': {
						width: arrowHeight, // reversed
						height: arrowWidth, // reversed
					},
				},
				'&[data-popper-placement="left"]': {
					'& .MuiTooltip-arrow': {
						':before': {
							marginTop: arrowHeight / 2,
						},
					},
				},
				'&[data-popper-placement="right"]': {
					'& .MuiTooltip-arrow': {
						':before': {
							marginTop: -arrowHeight / 2,
						},
					},
				},
				'&[data-popper-placement="top"]': {
					'& .MuiTooltip-arrow': {
						':before': {
							marginLeft: -arrowHeight / 2,
						},
					},
				},
				'&[data-popper-placement="bottom"]': {
					'& .MuiTooltip-arrow': {
						':before': {
							marginLeft: arrowHeight / 2,
						},
					},
				},
			},
			tooltip: {
				backgroundColor: globalTheme.palette.background.paper,
				color: globalTheme.palette.primary.main,
				...globalTheme.typography.body2,
				borderRadius: globalTheme.shape.borderRadius,
				boxShadow: `0 0 60px 0 rgba(0,0,0,0.17)`,
				padding: globalTheme.spacing(4, 3),
				maxWidth: 230,
				fontFamily: globalTheme.typography.fontFamily,
				fontWeight: globalTheme.typography.fontWeightRegular,
				margin: 0,
			},
			tooltipPlacementTop: {
				padding: globalTheme.spacing(4, 3),
			},
		},
	},
}

export default Tooltip
